import DataLayer from "./DataLayer";

export default (data) => {
    DataLayer.track({
        event: "checkout_option_shipping",
        ecommerce: {
            checkout: {
                actionField: { step: 1, option: data.option },
            },
        },
    });
};
